export const useVtickets = () => ({
  head: [
    {
      dataField: 'name',
      label: '',
    },
    {
      dataField: 'fullPrice',
      label: 'Preț',
    },
    {
      dataField: "discount",
      label: 'Early Bird',
    },
    {
      dataField: 'buyTicket',
      label: '',
    },
  ],
  data: [
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Conference Pass: VImagine'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '590 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '490 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Roman Burlaca'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '2460 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '1720 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Eduard Carp'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '750 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '550 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Riccardo Fasoli'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '4920 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '3930 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Evgeny Hollywood'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '1480 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '1240 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Raluca Rotund'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '750 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '550 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'Bilet Workshop Dima Vutcariov'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '750 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '550 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'PACHET Conference Pass VImagine + Workshop Riccardo Fasoli'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '5410 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '4170 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
    [
      {
        field: 'name',
        type: 'heading3',
        value: 'PACHET Conference Pass VImagine + Workshop Evgeny Hollywood'
      },
      {
        field: 'fullPrice',
        type: 'strikeParagraph',
        value: '1850 lei'
      },
      {
        field: "discount",
        type: 'strongParagraph',
        value: '1480 lei'
      },
      {
        field: 'buyTicket',
        type: 'buyButton',
        value: {
          text: 'CUMPĂRĂ',
          to: '/cumpara-bilet'
        }
      },
    ],
  ]
});